import VueRouter from "vue-router";
import store from "./store/index";

const routes = [
  /* ====== CORE ROUTES ====== */

  {
    path: "/",
    component: () => import("./pages/Cofocus/Home"),
    name: "Home",
  },

  {
    path: "/financials",
    component: () => import("./pages/Business/Financials"),
    name: "Financials",
  },

  {
    path: "/BETTER",
    component: () => import("./pages/Cofocus/BETTER"),
    name: "BETTER",
    meta: {
      isRotater: true,
    },
  },

  {
    path: "/FIGUREITOUT",
    component: () => import("./pages/Cofocus/FIGUREITOUT"),
    name: "FIGUREITOUT",
    meta: {
      isRotater: true,
    },
  },

  /* ====== COFOCUS INTERNAL STATS ====== */
  {
    path: "/internal",
    component: () => import("./pages/CofocusInternal/InternalStats"),
    name: "InternalStats",
  },

  {
    path: "/flamingo",
    component: () => import("./pages/CofocusInternal/Flamingo"),
    name: "Flamingo",
  },

  {
    path: "/us",
    component: () => import("./pages/CofocusInternal/Us"),
    name: "Us",
  },

  {
    path: "/masterboard",
    component: () => import("./pages/CofocusInternal/Masterboard/Masterboard"),
    name: "Masterboard",
  },

  {
    path: "/datamaster",
    component: () => import("./pages/CofocusInternal/Data/Data"),
    name: "Data",
  },

  {
    path: "/automation",
    component: () => import("./pages/CofocusInternal/Automation/Automation"),
    name: "Automation",
  },

  /* ====== DUMMY COFOCUS LANDING PAGE ====== */
  {
    path: "/dummycofocus",
    component: () => import("./pages/CofocusInternal/DummyCofocus"),
    name: "DummyCofocus",
    meta: {
      dummycofocus: true,
    },
  },
  {
    path: "/dummycofocus2",
    component: () => import("./pages/CofocusInternal/DummyCofocus2"),
    name: "DummyCofocus2",
    meta: {
      dummycofocus: true,
    },
  },

  /* ====== EMAIL SENDER ====== */

  {
    path: "/emails/:emailId",
    component: () => import("./pages/EmailManager/EmailBuilder"),
    name: "EmailBuilder",
    meta: {
      isEmailBuilder: true,
    },
  },

  {
    path: "/emails/sender/:emailId",
    component: () => import("./pages/EmailManager/EmailSender"),
    name: "EmailSender",
    meta: {
      isEmailSender: true,
    },
  },

  {
    path: "/emails",
    component: () => import("./pages/EmailManager/AllEmails"),
    name: "AllEmails",
  },

  /* ====== VISUALIZERS ====== */

  {
    path: "/visualizers",
    component: () => import("./pages/Visualizer/AllVisualizers"),
    name: "AllVisualizers",
  },

  {
    path: "/visualizer/:visualizerId",
    component: () => import("./pages/Visualizer/Visualizer"),
    name: "Visualizer",
    meta: {
      isVisualizer: true,
    },
  },

  /* ====== KANBANS ====== */

  {
    path: "/formcreator/:kanbanId",
    component: () => import("./pages/Form/FormCreator"),
    name: "FormCreator",
  },

  /* ====== KANBANS ====== */

  {
    path: "/kanbans",
    component: () => import("./pages/Kanban/AllKanbans"),
    name: "AllKanbans",
  },

  {
    path: "/kanban/:kanbanId",
    component: () => import("./pages/Kanban/Kanban"),
    name: "Kanban",
    meta: {
      isKanban: true,
    },
  },

  /* ====== AUTHENTICATION ROUTES ====== */
  {
    path: "/account/login",
    component: () => import("./pages/AuthPages/LoginPage"),
    name: "LoginPage",
    meta: {
      isLogin: true,
    },
  },

  /* ====== EVERYTHING ELSE ====== */

  {
    path: "/email",
    component: () => import("./mail/EmailDesigner"),
    name: "EmailDesigner",
  },

  /* ====== ERROR ROUTES ====== */

  {
    path: "/errors/404",
    name: "Error404",
    component: () => import("./pages/ErrorPages/Error404"),
  },

  { path: "*", redirect: "/errors/404" },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (!store.state.auth.ready) {
    try {
      await store.dispatch("auth/authenticate");
    } catch (err) {
      console.log("@router err: ", err);
    }
  }

  const authenticated = store.state.auth.authenticationStatus;

  if (!authenticated && !to.meta.isLogin) {
    next({ name: "LoginPage" });
  } else if (!authenticated && to.meta.isLogin) {
    next();
  } else if (authenticated && !to.meta.isLogin) {
    next();
  } else if (authenticated && to.meta.isLogin) {
    router.push("/");
  }
});

export default router;
